import { getFormProps, useForm } from '@conform-to/react'
import { Form } from 'react-router'
import { ErrorList } from '#app/components/forms.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { StatusButton } from '#app/components/ui/status-button.tsx'
import { cn, useIsPending } from '#app/utils/misc.tsx'

export function ScheduleActionButton({
	scheduleId,
	icon,
	value,
	text,
	variant,
	disabled = false,
	className,
}: {
	scheduleId: string
	icon: 'trash' | 'lock-open-1' | 'lock-closed' | 'envelope-closed'
	value: string
	text: string
	variant: 'default' | 'destructive' | 'secondary'
	disabled?: boolean
	className?: string
}) {
	const isPending = useIsPending()
	const [form] = useForm({ id: value })
	return (
		<Form method="POST" {...getFormProps(form)}>
			<input type="hidden" name="scheduleId" value={scheduleId} />
			<StatusButton
				type="submit"
				name="intent"
				value={value}
				variant={variant}
				status={form.status ?? 'idle'}
				disabled={isPending || disabled}
				className={cn('md:w-40', className)}
			>
				<Icon name={icon} className="scale-125 max-md:scale-150">
					<span className="text-nowrap text-ellipsis max-md:hidden">
						{text}
					</span>
				</Icon>
			</StatusButton>
			<ErrorList errors={form.errors} id={form.errorId} />
		</Form>
	)
}
